import { FaqComponent, Icon } from '@perch-labs/shrike';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '~/components/button';
import { Wrapper } from '~/components/customer-details/customer-details.style';
import { ErrorMessage } from '~/components/error-message';
import { GoogleSignup } from '~/components/google-signup';
import { TwoColumnGrid } from '~/components/layout';
import { Link } from '~/components/link';
import { Description, Text, Title } from '~/components/typography';
import { faqData } from '~/screens/signup/faq.data';
import { INTERNAL_ROUTES, LOGIN_URL, SPONSORED_SOLAR_ROUTES } from '~/utils/constants';
import { getSubRoute } from '~/utils/redirects';
import { signupCopy } from './signup.copy';
import { FaqButton } from './signup.style';

export const SignupComponent = props => {
  const { error } = props;
  const { title, description, buttons, links, isAlreadyRegistered } = signupCopy;
  const faqRef = useRef<HTMLDivElement>(null);
  const backToTopRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();
  return (
    <Wrapper ref={backToTopRef} style={{ border: 'none' }} testId="screen-Signup">
      <TwoColumnGrid>
        <TwoColumnGrid.Primary>
          <Title fontWeight={700} fontSize="28px">
            {title}
          </Title>
          <Description mb={5}>{description}</Description>
          {error ? <ErrorMessage error={error} /> : null}
          <FaqButton
            mode="default"
            fullWidth={false}
            testId="faq-button"
            onClick={() => {
              faqRef?.current?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            <Icon
              color="primary"
              icon="InfoCircleInverted"
              margin="5px"
              opacity="high"
              path="M 1,3 A 2,2 0,0,1 5,3 A 2,2 0,0,1 9,3 Q 9,6 5,9 Q 1,6 1,3 z"
              scale={2}
              title="InfoCircleInverted"
            />
            {buttons.labels.faq}
          </FaqButton>
          <GoogleSignup
            error=""
            redirectPath={`${getSubRoute(
              INTERNAL_ROUTES.SPONSORED_SOLAR,
              SPONSORED_SOLAR_ROUTES.GOOGLE_USER,
            )}`}
          />
          <hr />
          <Button
            testId="user-creation-button"
            mode="default"
            onClick={() => {
              navigate(
                getSubRoute(INTERNAL_ROUTES.SPONSORED_SOLAR, SPONSORED_SOLAR_ROUTES.USER_CREATION),
              );
            }}
          >
            <Icon
              color="primary"
              icon="Envelope"
              margin="5px"
              opacity="high"
              path="M 1,3 A 2,2 0,0,1 5,3 A 2,2 0,0,1 9,3 Q 9,6 5,9 Q 1,6 1,3 z"
              scale={2}
              title="Envelope"
            />
            {buttons.labels.emailSignUp}
          </Button>
          <Text textAlign="center" mt={5}>
            {isAlreadyRegistered}
            <Link color="primary" openInNewTab={false} href={LOGIN_URL}>
              {links.signIn}
            </Link>
            .
          </Text>
        </TwoColumnGrid.Primary>
        <TwoColumnGrid.Secondary style={{ marginLeft: '160px' }}>
          <Wrapper
            gridColumn="auto / span 2"
            display="flex"
            flexGrow={1}
            style={{ borderRadius: '0px' }}
          >
            <FaqComponent data={faqData} header="Frequently Asked Questions" />
          </Wrapper>
        </TwoColumnGrid.Secondary>
        <TwoColumnGrid.MobileOnlySecondary>
          <Wrapper
            ref={faqRef}
            gridColumn="auto / span 2"
            display="flex"
            flexGrow={1}
            style={{ borderRadius: '0px' }}
          >
            <FaqComponent data={faqData} header="Frequently Asked Questions" />
          </Wrapper>
          <Wrapper
            onClick={() => {
              backToTopRef?.current?.scrollIntoView({ behavior: 'smooth' });
            }}
            style={{
              textDecoration: 'underline',
              textUnderlineOffset: ' 2px',
            }}
          >
            <Text textAlign="center" mt={5} paddingBottom={5} textStyle="heading600">
              Back to top
              <Icon
                color="primary"
                icon="ArrowUp"
                margin="5px"
                opacity="high"
                path="M 1,3 A 2,2 0,0,1 5,3 A 2,2 0,0,1 9,3 Q 9,6 5,9 Q 1,6 1,3 z"
                scale={2}
                title="ArrowUp"
              />
            </Text>
          </Wrapper>
        </TwoColumnGrid.MobileOnlySecondary>
      </TwoColumnGrid>
    </Wrapper>
  );
};
